// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cms-root-KW0 {\n}\n\n.cms-heading-sxp {\n\n    /* Medium */\n}\n\n.cms-root_empty-U3Y,\n.cms-root_1column--u6,\n.cms-root_2columnsLeft-Nov,\n.cms-root_2columnsRight-cyA,\n.cms-root_3columns-BoF,\n.cms-root_cmsFullWidth-bCA,\n.cms-root_categoryFullWidth-tbj,\n.cms-root_productFullWidth-CzL {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "cms-root-KW0 px-4",
	"heading": "cms-heading-sxp mb-2 mt-4 text-center text-3xl md_mb-10 md_text-4xl",
	"root_empty": "cms-root_empty-U3Y cms-root-KW0 px-4",
	"root_1column": "cms-root_1column--u6 cms-root-KW0 px-4",
	"root_2columnsLeft": "cms-root_2columnsLeft-Nov cms-root-KW0 px-4",
	"root_2columnsRight": "cms-root_2columnsRight-cyA cms-root-KW0 px-4",
	"root_3columns": "cms-root_3columns-BoF cms-root-KW0 px-4",
	"root_cmsFullWidth": "cms-root_cmsFullWidth-bCA cms-root-KW0 px-4",
	"root_categoryFullWidth": "cms-root_categoryFullWidth-tbj cms-root-KW0 px-4",
	"root_productFullWidth": "cms-root_productFullWidth-CzL cms-root-KW0 px-4"
};
export default ___CSS_LOADER_EXPORT___;
